<template>
    <div class="text-center">
        <div class="d-flex justify-content-between align-items-center">
          <router-link
             to="/inventory/columns"
            class="btn btn-secondary"
            ><i class="fa fa-reply fa-lg"></i> Volver
          </router-link>

          <button
            type="submit"
            class="btn btn-info"
            @click="$emit('onAction')"
          >
            <i :class="getBtnIcon" /> {{ getBtnTitle }}
          </button>
        </div>
      </div>
</template>

<script>
export default {
    name: "ContentBtns",

    props: {
        scopeForm: {
            type: String,
            required: false,
            default: "create",
        },
    },

    computed: {
        getBtnTitle() {
            return this.scopeForm === "create" ? "Crear columna" : "Actualizar columna";
        },
        getBtnIcon() {
            return this.scopeForm === "create" ? "fa fa-plus" : "fa fa-pencil";
        },
    },

}
</script>